<ng-container *ngIf="searchTips">
  <div class="empty-list-container body-text-base">
    <ng-container *ngFor="let searchTip of searchTips">
      <div class="empty-list-inner-container">
        <div class="left-content">
          <span class="icon2 icon2-x24-idea"></span>
        </div>
        <!-- We added innerHtml so that some html can be rendered as well -->
        <div class="right-content pl-8" [innerHTML]="searchTip?.tip"></div>
      </div>
    </ng-container>
  </div>
</ng-container>
